/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderEditCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderEditCtrl', ["dialog", "$filter", "ngToast", "$q", "$scope", "$state", "$stateParams", "StockBrands", "StockItems", "StockUnits", "StockPurchaseOrders", "$timeout", "title", "userinfo", "SalesTax", "StockCost", function(dialog, $filter, ngToast, $q, $scope, $state, $stateParams,
  StockBrands, StockItems, StockUnits, StockPurchaseOrders, $timeout, title, userinfo, SalesTax, StockCost) {
  title.set('View Purchase Order');

  /**
  * Initial Setup
  */
  $scope.items = StockItems.getAllStockApi();
  $scope.allUnits = StockUnits.getAllStockApi(true);
  $scope.brands = StockBrands.getAllActive();
  $scope.taxRates = SalesTax.getCompanySalesTaxAmounts();

  if ($stateParams.id) {
    $scope.order = StockPurchaseOrders.get($stateParams.id);
  } else if ($stateParams.supplierId && $stateParams.date) {
    $scope.order = StockPurchaseOrders.getAdjusting($stateParams.supplierId, $stateParams.date);
    $scope.order.$promise.then(function() {
      delete $scope.order.id;
      angular.forEach($scope.order.lines, function(line) {
        delete line.id;
      });

      $scope.order.orderedBy = userinfo.userDetails().name;
      $scope.order.datestampReceived = moment($stateParams.date).subtract(1, 'second').format();
      $scope.order.datestampInvoiced = moment($stateParams.date).subtract(1, 'second').format();
    });
  } else {
    $scope.finish();
  }

  $scope.taxRates.then(function(result) {
    $scope.taxRates = result;
  });

  $scope.taxReady = $q.all([$scope.order.$promise, $scope.taxRates]);

  $scope.loading = $q.all([
      $scope.order.$promise,
      $scope.items.$promise,
      $scope.allUnits.$promise,
      $scope.brands.$promise
  ]);

  $scope.loading.then(function() {
    $scope.order.stockCodeValid = true;
    $scope.units = $scope.allUnits.filter(u => u.datestampDeleted === null);
    if (!$scope.order.received) {
      $scope.order.datestampReceived = moment().format();
      $scope.order.datestampInvoiced = moment().format();
    }
  }, function() {
    $scope.finish();
  });

  /**
  * Updates subtotal, total and tax in the model.
  */
  $scope.orderEditTotal = function() {
    var total = 0;
    var totalLineTax = 0;
    angular.forEach($scope.order.lines, function(line) {
      if (line.unitCost && line.quantity) {
        total += line.unitCost * line.quantity;
        totalLineTax += (line.unitCost * line.quantity) * line.taxPercent;
      }
    });

    if (!$scope.order.freight) {
      $scope.order.freight = 0;
    }

    $scope.order.subtotal = total;
    // TODO: calculate tax on freight
    var freight = parseFloat($scope.order.freight);

    var freightTax = freight * $scope.order.freightTaxPercent;

    $scope.order.total = total + totalLineTax + freightTax + freight;
  };

  /**
  * Filter up changes to the order lines when the subtotal is changed.
  */
  $scope.updateUnitCostsFromSubtotal = function() {
    if (angular.isDefined($scope.order.subtotal) === false) {
      return;
    }

    var totalQuantity = 0;
    var totalCost = 0;

    angular.forEach($scope.order.lines, function(orderLine) {
      if (orderLine.quantity && orderLine.unitCost) {
        totalQuantity += orderLine.quantity / orderLine.unitRatio;
        totalCost += orderLine.unitCost * orderLine.quantity;
      }
    });

    angular.forEach($scope.order.lines, function(orderLine) {
      if (totalQuantity === 0) {
        orderLine.unitCost = $scope.order.subtotal / $scope.order.lines.length;
        orderLine.quantity = 1;
      } else if (totalCost === 0) {
        orderLine.unitCost = $scope.order.subtotal / totalQuantity;
      } else {
        var ratio = $scope.order.subtotal / totalCost;
        orderLine.unitCost = orderLine.unitCost * ratio;
      }
    });

    $scope.order.total = (parseFloat($scope.order.subtotal) + $scope.order.freight) * 1.15;
    $scope.order.tax = $scope.order.total - parseFloat($scope.order.subtotal);
  };

  $scope.itemOptions = function() {
    var existingItems = {};
    angular.forEach($scope.order.lines, function(line) {
      existingItems[line.stockItemId] = true;
    });

    var avaliableItems = [];
    angular.forEach($scope.items, function(item) {
      if (!existingItems[item.id]) {
        avaliableItems.push(item);
      }
    });
    return avaliableItems;
  };

  var validateStockCode = function(line) {
    if ($scope.order.supplierValidateStockCode === false) {
      return;
    }

    StockItems.searchStockcodes(line.stockCode, $scope.order.supplierId)
    .$promise.then(function(supplierItems) {
      var isValid = false;
      angular.forEach(supplierItems, function(supplierItem) {
        if (supplierItem.itemCode == line.stockCode) {
          isValid = true;
        }
      });

      line.stockCodeValid = isValid;
      $scope.order.stockCodeValid = $filter('filter')($scope.order.lines, {stockCodeValid: false}).length === 0;
    });
  };

  /**
   * Fetch the stockcode and cost for a line from the server. Then
   * validate that stock code if required
   */
  var getStockCode = function(line, ignoreUnitCost) {
    StockItems.getItemSupplier(
      line.stockItemId,
      line.unitId,
      $scope.order.supplierId,
      line.brandId
    ).then(function(result) {
      if (result) {
        line.stockCode = result.stockCode;
        if (!ignoreUnitCost){
          line.unitCost = result.unitCost;
        }
        $scope.orderEditTotal();
      } else {
        line.stockCode = '';
      }

      validateStockCode(line);
    });
  };

  /**
  * Add a new line to the order
  */
  $scope.addItem = function(value) {
    // Putting the stock cost request first so it returns ASAP
    var stockCostPromise = StockCost.get([`${value.id},${moment().format()}`])
    // Items Created via the moreItems dialog are created via WebAPI and thus will have no variants hence the '?'.
    // This can be removed when we update this workfow.
    var defaultVariant = !value.suppliers 
      ? undefined 
      : value.suppliers.find(variant => variant.supplierId === $scope.order.supplierId && variant.defaultForSupplier);

    var baseOrderLine = {
      purchaseOrderId: $scope.order.id,
      quantityOrdered: 0,
      unitCostOrdered: 0,
      unitCost: 0,
      stockItemId: value.id,
      stockItemName: value.name,
      taxPercent: $scope.taxRates.data[1].amount,
      costPromise: stockCostPromise
    }

    // If there is a default variant for this supplier then we use that otherwise just use 
    // the parent item's values
    if (defaultVariant) {
      var variantUnit = $scope.allUnits.find(u => u.id === defaultVariant.unitId);
      var variantBrand = $scope.brands.find(b => b.id === defaultVariant.brandId);

      $scope.order.lines.push(
        Object.assign(
          baseOrderLine, 
          {
            stockCode: defaultVariant.stockCode ? defaultVariant.stockCode : '',
            quantity: 1 * variantUnit.ratio,
            brandId: variantBrand ? variantBrand.id : undefined,
            brandName: variantBrand ? variantBrand.name : undefined,
            unitName: variantUnit.name,
            unitId: variantUnit.id,
            unitRatio: variantUnit.ratio,
          }
        )
      );
    } else {
      var orderingUnit = $scope.allUnits.find(u => u.id === value.orderingUnitId); 
      var defaultBrand = $scope.brands.find(b => b.id === value.defaultBrandId);

      $scope.order.lines.push(
        Object.assign(
          baseOrderLine,
          {
            stockCode: 'Loading...',
            quantity: 1 * orderingUnit.ratio,
            brandId: value.defaultBrandId,
            brandName: defaultBrand ? defaultBrand.name : undefined,
            unitName: value.orderingUnitName,
            unitId: value.orderingUnitId,
            unitRatio: orderingUnit.ratio,
          }
        )
      );
      getStockCode($scope.order.lines[$scope.order.lines.length - 1], true);
    }

    // Update the unitCost of the line to be what cost of what the StockCost request returns.
    // As this is within a single call of the addItem we know `$scope.order.lines.length - 1` 
    // as the index refers to the correct line.
    // Also update the totals 
    $scope.order.lines[$scope.order.lines.length - 1].costPromise
      .then(stockCost => {
        $scope.order.lines[$scope.order.lines.length - 1].unitCost = stockCost.itemCosts[value.id][0].cost
        $scope.orderEditTotal();
      })

    $scope.purchaseOrderForm.itemToAdd.$setValidity('haslines', true);
  };

  $scope.updateBrand = function(line) {
    getStockCode(line);

    angular.forEach($scope.items, function(item, index) {
      if (item.id == line.stockItemId && line.brandId != item.defaultBrandId) {
        var confirmMsg = 'The brand you have selected is not the default for this item. ' +
          'Would you like to use this brand as the default in the future?';
        dialog.confirm(confirmMsg)
        .then(function(confirmed) {
          if (confirmed) {
            StockItems.patch(line.stockItemId, 'DefaultBrandId', line.brandId)
            .then(function() {
              $scope.items[index].defaultBrandId = line.brandId;
              $scope.items[index].defaultBrandName = line.brandName;
            });
          }
        });
      }
    });
  };

  $scope.updateUnit = function(line, newUnit) {
    getStockCode(line);

    line.quantity = (line.quantity / line.unitRatio) * newUnit.ratio;
    line.unitCost = (line.unitCost * line.unitRatio) / newUnit.ratio;
    line.unitRatio = newUnit.ratio;

    angular.forEach($scope.items, function(item, index) {
      if (item.id == line.stockItemId && line.unitId != item.orderingUnitId) {
        var confirmMsg = 'The ordering unit you have selected is not the default for this item. ' +
        'Would you like to use this unit as the default in the future?';

        dialog.confirm(confirmMsg)
        .then(function(confirmed) {
          if (confirmed) {
            StockItems.patch(line.stockItemId, 'OrderingUnitId', line.unitId)
            .then(function() {
              $scope.items[index].orderingUnitId = line.unitId;
              $scope.items[index].orderingUnitName = line.unitName;
            });
          }
        });
      }
    });
  };

  /**
  * delete a purchase order.
  */
  $scope.deleteOrder = function() {
    StockPurchaseOrders.remove($scope.order)
    .then(function() {
      $scope.finish();
    });
  };

  /**
  * Restore a deleted purchase order.
  */
  $scope.restoreOrder = function() {
    StockPurchaseOrders.restore($scope.order)
    .then(function() {
      $scope.finish();
    });
  };

  /**
  * Remove a order line
  */
  $scope.removeLine = function(index) {
    $scope.order.lines.splice(index, 1);

    $scope.purchaseOrderForm.itemToAdd.$setValidity('haslines', $scope.order.lines.length > 0);

    $scope.orderEditTotal();
  };

  /**
  * Save changes to an order to the server
  */
  $scope.saveOrder = function() {
    $scope.purchaseOrderForm.$setSubmitted();
    $scope.purchaseOrderForm.itemToAdd.$setValidity('haslines', $scope.order.lines.length > 0);

    if ($scope.purchaseOrderForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this order.');
      return;
    }

    if ($scope.order.received && $scope.order.id) {
      dialog.confirm('This purchase order has previously been receipted. Changing it now will retrospectively' +
        ' modify your stock levels which may result in unpredictable behaviour.')
      .then(function(confirmed) {
        if (confirmed) {
          $scope.savingOrder = StockPurchaseOrders.update($scope.order);
          $scope.savingOrder.then(function() {
            $scope.finish();
          });
        }
      });
    } else {
      $scope.savingOrder = StockPurchaseOrders.update($scope.order);
      $scope.savingOrder.then(function() {
        $scope.finish();
      });
    }
  };

  $scope.receiveGoods = function() {
    $scope.receivingOrder = StockPurchaseOrders.receive($scope.order);
    $scope.receivingOrder.then(function() {
      $scope.finish();
    });
  };

  $scope.finish = function() {
    if ($stateParams.return) {
      var returnParams = JSON.parse($stateParams.return);
      $state.go(returnParams.name, returnParams.params);
    } else {
      $state.go($state.current.data.menuLinkState, {report: $stateParams.report});
    }
  };

  $scope.unitsMore = function(line) {
    dialog.open({
      controller: 'StockUnitPopupCtrl',
      templateUrl: 'modules/stock/unit/popup.tpl.html',
      resolve: {
        onAdd: function() {
          return function(newUnit) {
            $scope.units.push(newUnit);
          };
        }
      }
    }).then(function(result) {
      line.unitId = result.id;
      line.unitName = result.name;

      $scope.updateUnit(line);
    });
  };

  $scope.brandsMore = function(line) {
    dialog.open({
      controller: 'StockBrandPopupCtrl',
      templateUrl: 'modules/stock/brand/popup.tpl.html',
      resolve: {
        onAdd: function() {
          return function(newBrand) {
            $scope.brands.push(newBrand);
          };
        }
      }
    }).then(function(result) {
      line.brandId = result.id;
      line.brandName = result.name;

      $scope.updateBrand(line);
    });
  };

  $scope.itemsMore = function() {
    dialog.open({
      controller: 'StockItemPopupCtrl',
      templateUrl: 'modules/stock/item/popup.tpl.html',
      size: 'lg',
      resolve: {
        existingItems: function() {
          var result = [];
          angular.forEach($scope.order.lines, function(line) {
            result.push(line.stockItemId);
          });
          return result;
        },
        onItemAdd: function() {
          return function(newItem) {
            $scope.items.push(newItem);
          };
        },
        onBrandAdd: function() {
          return function(newBrand) {
            $scope.brands.push(newBrand);
          };
        },
        onSupplierAdd: function() {
          return function() { };
        }
      }
    }).then(function(result) {
      $scope.addItem(result);
    });
  };

  $scope.stockcodeMore = function(line) {
    dialog.open({
      controller: 'StockPurchaseorderPopupstockcodesCtrl',
      templateUrl: 'modules/stock/purchaseorder/popupstockcodes.tpl.html',
      size: 'lg',
      resolve: {
        stockSupplierId: function() {
          return $scope.order.supplierId;
        }
      }
    }).then(function(result) {
      line.stockCode = result.itemCode;
      $scope.stockcodeSelected(line);
    });
  };

  $scope.searchStockCodes = function(searchStr, line) {
    line.stockCode = searchStr;

    return StockItems.searchStockcodes(searchStr, $scope.order.supplierId).$promise;
  };

  $scope.stockcodeSelected = function(line) {
    line.stockCodeValid = true;
    $scope.order.stockCodeValid = $filter('filter')($scope.order.lines, {stockCodeValid: false}).length === 0;
  };

  $scope.stockcodeLine = function(item) {
    return '<div style="display: inline-block; width: 100px">' + item.value.itemCode + '</div>' +
      '<div style="display: inline-block; width: 200px">' + item.value.name + '</div>' +
      '<div style="display: inline-block; width: 200px">' + (item.value.unit || 'Not Set') + '</div>' +
      '<div style="display: inline-block; width: 200px">' + (item.value.brand || 'Not Set') + '</div>';
  };

  $scope.stockcodeHeader = function() {
    return '<li class="ui-autocomplete-category ui-autocomplete-category-header"><div style="display: inline-block; width: 100px">Code</div>' +
      '<div style="display: inline-block; width: 200px">Description</div>' +
      '<div style="display: inline-block; width: 200px">Unit</div>' +
      '<div style="display: inline-block; width: 200px">Brand</div></li>';
  };

  $scope.isPromisePending = function(promise) {
    return promise && promise.$$state.status == 0;
  }

  $scope.allLinePromisesResolved = function() {
    var lines = $scope.order.lines;
    return lines && lines.every(l => !$scope.isPromisePending(l.costPromise))
  }
}]);
